import { TStatisticData } from '../../store/reducers/dashboardSlice';

export const getMappedSumTabs = (data: TStatisticData[] | null) => {
  if (!data) return { outward: 0, inward: 0, transfer: 0, fx: 0 };

  return data.reduce(
    (acc, item) => {
      acc = {
        ...acc,
        outward: acc.outward + item.outward,
        inward: acc.inward + item.inward,
        transfer: acc.transfer + item.transfer,
        fx: acc.fx + item.fx,
      };

      return acc;
    },
    { outward: 0, inward: 0, transfer: 0, fx: 0 } as {
      outward: number;
      inward: number;
      transfer: number;
      fx: number;
    }
  );
};
